@if (!config.hidden) {
  @if (config.type == "button") {
    <button
      type="button"
      [class]="
        `w-100 btn btn-${config.size || defaultConfig.btn.size} btn-${config.color ? config.color : defaultConfig.btn.color} btn-${config.color ? config.color : defaultConfig.btn.color}-${config.theme || defaultConfig.theme} ${config.bgColor && `bg-${config.bgColor}`} ${config.animation ? `${config.animation} ` : ' '} `
      "
      [style]="`${config.disabled ? 'pointer-events: none; opacity: .9' : ''}`"
      (click)="`${config.action && config.action(data)}`"
    >
      @if (config.startContent) {
        <div class="d-none d-md-block">
          <ng-container
            *ngComponentOutlet="
              config.startContent.content;
              inputs: config.startContent.data
            "
          />
        </div>
      }
      <span class="btn-text">
        {{ config.label.key | translate: config.label.params }}
      </span>
      @if (config.endContent) {
        <div class="d-none d-md-block">
          <ng-container
            *ngComponentOutlet="
              config.endContent.content;
              inputs: config.endContent.data
            "
          />
        </div>
      }
    </button>
  } @else if (config.type == "action") {
    <button
      placement="bottom"
      [ngbTooltip]="getLabelTranslation(config.label)"
      triggers="hover"
      type="button"
      [class]="
        `p-0 btn btn-${config.size} btn-${config.color} btn-${config.color}-${config.theme} ${config.bgColor && `bg-${config.bgColor}`}`
      "
      [style]="`${config.disabled ? 'pointer-events: none; opacity: .9' : ''}`"
      (click)="`${config.action(data)}`"
    >
      <icon
        class="btn-icon"
        style="padding: 8px !important"
        [icon]="config.icon"
        [size]="
          `${config.size ? iconSizes[config.size] : defaultConfig.icon.size}`
        "
      />
    </button>
  } @else if (config.type == "link") {
    <a
      [routerLink]="config.route"
      [class]="
        `w-100 btn gap-3 btn-${config.size || defaultConfig.btn.size} btn-${config.color || defaultConfig.btn.color} btn-${config.color}-${config.theme || defaultConfig.theme} ${config.bgColor && `bg-${config.bgColor}`} ${config.animation ? `${config.animation} ` : ' '} `
      "
      [style]="
        `${config.disabled ? 'pointer-events: none; opacity: .9; justify-content: start;' : 'justify-content: start;'}`
      "
    >
      @if (config.startContent) {
        <div class="d-none d-md-block">
          <ng-container
            *ngComponentOutlet="
              config.startContent.content;
              inputs: config.startContent.data
            "
          />
        </div>
      }
      @if (config.label) {
        <span class="btn-text">
          {{ config.label.key | translate: config.label.params }}
        </span>
      }
      @if (config.endContent) {
        <div class="d-none d-md-block">
          <ng-container
            *ngComponentOutlet="
              config.endContent.content;
              inputs: config.endContent.data
            "
          />
        </div>
      }
    </a>
  } @else {
    <button
      type="button"
      [class]="
        `p-0 btn btn-${config.size} btn-${config.color} btn-${config.color}-${config.theme} ${config.bgColor && `bg-${config.bgColor}`}`
      "
      [style]="`${config.disabled ? 'pointer-events: none; opacity: .9' : ''}`"
      (click)="`${config.action && config.action(data)}`"
    >
      @if (config.label) {
        <icon
          class="btn-icon"
          style="padding: 8px !important"
          [icon]="config.icon"
          placement="bottom"
          [ngbTooltip]="tooltipTemplate"
          tooltipClass="biometric-tooltip"
          container="body"
          [size]="
            `${config.size ? iconSizes[config.size] : defaultConfig.icon.size}`
          "
        />
        <ng-template #tooltipTemplate>
          <div [innerHTML]="getLabelTranslation(config.label)"></div>
        </ng-template>
      } @else {
        <icon
          class="btn-icon"
          style="padding: 8px !important"
          [icon]="config.icon"
          [size]="
            `${config.size ? iconSizes[config.size] : defaultConfig.icon.size}`
          "
        />
      }
    </button>
  }
}
